// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fun_tinker {
    text-align: center;
    background-color: repeating-radial-gradient(45deg, #e902ed, #16167c, #00d4ff); /* Color de fondo de la tarjeta */
    border: none;
    border-radius: 5px; /* Bordes redondeados */
    width: 100%;
    padding: 20px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* Sombra de la tarjeta */
    font-size: 2rem;
    color: #212529; /* Color de texto inicial */
    cursor: pointer;
    transition: transform 0.2s ease-in-out, color 0.3s ease-in-out; /* Añadido color a la transición */
}
.fun_tinker:hover {
    transform: scale(1.1); /* Aumenta el tamaÃ±o */
    color: #010802;
    background-color: repeating-radial-gradient(45deg, #e902ed, #16167c, #00d4ff);
}

.clock-face {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    background-color: #f3f3f3;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 5px solid #333;
    margin: 20px 0;
}

.clock-time {
    font-size: 12vmin;
    font-weight: bold;
}

.scoreboard {
    font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif  ; 
    color: rgb(0, 0, 0);  
    display: inline-block;
    margin-top: -0.5vmin;
    position: fixed;
    top: 15%;
    right: 11%;
    z-index: 100; 
}

@keyframes shine {
    0% {
      background-position: 500%;
    }
    100% {
      background-position: -500%;
    }
  }
  
  .shiny-text {
    background-image: linear-gradient(
      120deg,
      rgba(255, 255, 255, 0.1) 0%,
      rgba(255, 255, 255, 0.5) 50%,
      rgba(255, 255, 255, 0.1) 100%
    );
    background-size: 200%;
    animation: shine 30s linear infinite;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/halloweenThinkers/thinkers.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,6EAA6E,EAAE,iCAAiC;IAChH,YAAY;IACZ,kBAAkB,EAAE,uBAAuB;IAC3C,WAAW;IACX,aAAa;IACb,0CAA0C,EAAE,yBAAyB;IACrE,eAAe;IACf,cAAc,EAAE,2BAA2B;IAC3C,eAAe;IACf,8DAA8D,EAAE,kCAAkC;AACtG;AACA;IACI,qBAAqB,EAAE,uBAAuB;IAC9C,cAAc;IACd,6EAA6E;AACjF;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,wEAAwE;IACxE,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;IACpB,eAAe;IACf,QAAQ;IACR,UAAU;IACV,YAAY;AAChB;;AAEA;IACI;MACE,yBAAyB;IAC3B;IACA;MACE,0BAA0B;IAC5B;EACF;;EAEA;IACE;;;;;KAKC;IACD,qBAAqB;IACrB,oCAAoC;EACtC","sourcesContent":[".fun_tinker {\n    text-align: center;\n    background-color: repeating-radial-gradient(45deg, #e902ed, #16167c, #00d4ff); /* Color de fondo de la tarjeta */\n    border: none;\n    border-radius: 5px; /* Bordes redondeados */\n    width: 100%;\n    padding: 20px;\n    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* Sombra de la tarjeta */\n    font-size: 2rem;\n    color: #212529; /* Color de texto inicial */\n    cursor: pointer;\n    transition: transform 0.2s ease-in-out, color 0.3s ease-in-out; /* Añadido color a la transición */\n}\n.fun_tinker:hover {\n    transform: scale(1.1); /* Aumenta el tamaÃ±o */\n    color: #010802;\n    background-color: repeating-radial-gradient(45deg, #e902ed, #16167c, #00d4ff);\n}\n\n.clock-face {\n    width: 150px;\n    height: 150px;\n    border-radius: 50%;\n    background-color: #f3f3f3;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 5px solid #333;\n    margin: 20px 0;\n}\n\n.clock-time {\n    font-size: 12vmin;\n    font-weight: bold;\n}\n\n.scoreboard {\n    font-family: Impact, Haettenschweiler, \"Arial Narrow Bold\", sans-serif  ; \n    color: rgb(0, 0, 0);  \n    display: inline-block;\n    margin-top: -0.5vmin;\n    position: fixed;\n    top: 15%;\n    right: 11%;\n    z-index: 100; \n}\n\n@keyframes shine {\n    0% {\n      background-position: 500%;\n    }\n    100% {\n      background-position: -500%;\n    }\n  }\n  \n  .shiny-text {\n    background-image: linear-gradient(\n      120deg,\n      rgba(255, 255, 255, 0.1) 0%,\n      rgba(255, 255, 255, 0.5) 50%,\n      rgba(255, 255, 255, 0.1) 100%\n    );\n    background-size: 200%;\n    animation: shine 30s linear infinite;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
